import { grey2 } from './colors';
export var defaultBoxShadow = '0px 3px 3px 0px rgba(0, 0, 0, 0.13), 0px 1px 7px 0px rgba(0, 0, 0, 0.19)';
export var hoverBoxShadow = '0px 10px 20px 0px rgba(0, 0, 0, 0.13), 0px 3px 9px 0px rgba(0, 0, 0, 0.19)';
export var alternateBoxShadow = "0.1rem 0.1rem 0.2rem " + grey2;